/* eslint-disable no-shadow */
export enum WidgetCategoryEnum {
  danger = 'danger',
  readOnly = 'readOnly',
  userSpecific = 'userSpecific',
}

export enum FunderCollaborationTabsEnum {
  goalGroupCreation = 'goalGroupCreation',
  goalCreation = 'goalCreation',
  chartCreation = 'chartCreation',
}
